module.exports = __webpack_public_path__ + "img/ideal.d6b2246.png";